document.addEventListener("DOMContentLoaded", function () {
    console.log("PayWhirl Script Loaded");

    // Initialize PayWhirl widget (one-time/subscription)
    initializePayWhirlWidget();

    // Initialize Multiple Buy options (quantity breaks)
    waitForMultipleBuyOptions();
});

/************************************
 * Global Price Storage
 ************************************/
window.globalPrices = {
    payWhirl: {
        oneTime: {
            price: null // e.g. "£11.99"
        },
        subscription: {
            price: null,      // Could be empty if not selected initially
            groupPrice: null, // Often available as "£8.99" or similar
            compareAt: null
        }
    },
    multipleBuy: {
        options: [],       // { quantityValue, discountedPrice, originalPrice }
        selectedOption: null,
        selectedPrice: null
    }
};

/************************************
 * Utility Functions
 ************************************/
function parsePrice(str) {
    if (!str) return 0;
    return parseFloat(str.replace(/[^0-9.]/g, '')); // remove currency and parse float
}

function formatPrice(num) {
    return `£${num.toFixed(2)}`;
}

/**
 * Recalculate and update the PayWhirl widget prices based on the current selected quantity and
 * whether subscription or one-time is selected.
 */
function updatePayWhirlPrices() {
    const oneTimePriceElement = getOneTimePriceElement();
    const subscriptionGroupPriceElement = getSubscriptionGroupPriceElement();
    const { comparePriceElement, priceElement } = getSubscriptionPriceElements();

    // Get currently selected quantity option data
    const selectedOptionValue = window.globalPrices.multipleBuy.selectedOption;
    const optionData = window.globalPrices.multipleBuy.options.find(o => o.quantityValue === selectedOptionValue);

    if (!optionData) {
        console.log("No selected Multiple Buy option data found. Cannot update prices.");
        return;
    }

    // Update one-time price directly from the selected option's discounted price
    if (oneTimePriceElement) {
        oneTimePriceElement.innerText = optionData.discountedPrice;
        // Re-apply after delay to prevent overrides
        setTimeout(() => {
            oneTimePriceElement.innerText = optionData.discountedPrice;
        }, 300);
    }

    // Determine the base subscription price:
    // If subscription.price is empty or null, fallback to subscription.groupPrice
    let baseSubscriptionPriceStr = window.globalPrices.payWhirl.subscription.price;
    if (!baseSubscriptionPriceStr || !baseSubscriptionPriceStr.trim()) {
        baseSubscriptionPriceStr = window.globalPrices.payWhirl.subscription.groupPrice;
    }

    const baseSubscriptionPrice = parsePrice(baseSubscriptionPriceStr);
    const baseSubscriptionCompareAt = parsePrice(window.globalPrices.payWhirl.subscription.compareAt);

    const quantity = parseInt(optionData.quantityValue, 10) || 1;

    // Subscription price for selected quantity
    const finalSubPrice = baseSubscriptionPrice * quantity;
    const finalSubPriceStr = formatPrice(finalSubPrice);

    // Compare-At price for subscription (if available), also scaled by quantity
    let finalComparePriceStr = null;
    if (baseSubscriptionCompareAt && baseSubscriptionCompareAt > 0) {
        const finalComparePrice = baseSubscriptionCompareAt * quantity;
        finalComparePriceStr = formatPrice(finalComparePrice);
    }

    const selectedPlan = document.querySelector('input[name="paywhirl-plan-selector-group"]:checked');
    const isSubscriptionSelected = selectedPlan && selectedPlan.value !== "";

    if (isSubscriptionSelected) {
        // Subscription selected - update the subscription visible price & compare-at
        if (comparePriceElement && priceElement) {
            if (finalComparePriceStr) {
                comparePriceElement.innerText = finalComparePriceStr;
            } else if (comparePriceElement) {
                // If no compare-at, clear or leave as is
                comparePriceElement.innerText = "";
            }

            priceElement.innerText = finalSubPriceStr;

            // Re-apply after a delay in case of overrides
            setTimeout(() => {
                if (finalComparePriceStr) {
                    comparePriceElement.innerText = finalComparePriceStr;
                } else if (comparePriceElement) {
                    comparePriceElement.innerText = "";
                }
                priceElement.innerText = finalSubPriceStr;
            }, 300);
        }
    } else {
        // One-time selected - update the subscription group price (unselected state)
        if (subscriptionGroupPriceElement) {
            subscriptionGroupPriceElement.innerText = finalSubPriceStr;
            // Re-apply after a delay
            setTimeout(() => {
                subscriptionGroupPriceElement.innerText = finalSubPriceStr;
            }, 300);
        }
    }
}

/************************************
 * PayWhirl Widget Functions
 ************************************/
function initializePayWhirlWidget() {
    const widget = getPayWhirlWidget();
    if (!widget) return;

    const elements = getPayWhirlWidgetElements(widget);
    if (!elements) return;

    logInitialPayWhirlPrices(elements);
    attachPayWhirlOptionListeners(elements);
}

function getPayWhirlWidget() {
    const widget = document.getElementById("paywhirl-plan-selector-0");
    if (!widget) {
        console.error("PayWhirl widget not found!");
        return null;
    }
    console.log("PayWhirl widget found.");
    return widget;
}

function getPayWhirlWidgetElements(widget) {
    const oneTimeGroup = widget.querySelector("#paywhirl-one-time-purchase-group");
    const subscriptionGroup = widget.querySelector("#paywhirl-plan-selector-group-22a3d0d027fcdf40dec221093eff9c2be9d9623d");
    const optionRadios = widget.querySelectorAll('input[name="paywhirl-plan-selector-group"]');

    if (!optionRadios.length) {
        console.error("No PayWhirl plan selector radios found!");
        return null;
    }

    if (!oneTimeGroup) console.warn("One-time purchase group not found!");
    if (!subscriptionGroup) console.warn("Subscription group not found!");

    return { widget, oneTimeGroup, subscriptionGroup, optionRadios };
}

function logInitialPayWhirlPrices({ oneTimeGroup, subscriptionGroup }) {
    console.log("Logging initial PayWhirl prices...");
    logPayWhirlPrices(oneTimeGroup, "One-time Option");
    logPayWhirlPrices(subscriptionGroup, "Subscription Option");
}

function attachPayWhirlOptionListeners({ optionRadios }) {
    optionRadios.forEach((radio) => {
        console.log("Attaching listener to PayWhirl option radio:", radio.value);
        radio.addEventListener("change", function (e) {
            console.log("PayWhirl option changed:", e.target.value);
            if (e.target.value === "") {
                console.log("One-time option selected.");
            } else {
                console.log("Subscription option selected. Group ID:", e.target.value);
            }
            // After plan change, re-update prices based on current quantity
            updatePayWhirlPrices();
        });
    });
}

function logPayWhirlPrices(group, label) {
    if (!group) {
        console.warn(`${label} group is not available.`);
        return;
    }

    console.log(`---- ${label} Prices ----`);
    const priceEl = group.querySelector(".paywhirl-plan-selector-price .paywhirl-price");
    const groupPriceEl = group.querySelector(".paywhirl-plan-selector-group-price .paywhirl-price");
    const compareAtEl = group.querySelector(".paywhirl-plan-selector-price .paywhirl-compare-at-price");

    let priceVal = priceEl ? priceEl.textContent.trim() : null;
    let groupPriceVal = groupPriceEl ? groupPriceEl.textContent.trim() : null;
    let compareAtVal = compareAtEl ? compareAtEl.textContent.trim() : null;

    if (priceEl) {
        console.log(`${label} Price:`, priceVal);
    } else {
        console.log(`No price element found for ${label}.`);
    }

    if (groupPriceEl) {
        console.log(`${label} Group Price (unselected state):`, groupPriceVal);
    } else {
        console.log(`No group price element found for ${label}.`);
    }

    if (compareAtEl) {
        console.log(`${label} Compare-At Price:`, compareAtVal || "<empty string>");
    } else {
        console.log(`No compare-at price element found for ${label}.`);
    }

    console.log(`---- End of ${label} Prices ----`);

    // Store globally
    if (label === "One-time Option") {
        window.globalPrices.payWhirl.oneTime.price = priceVal;
    } else if (label === "Subscription Option") {
        window.globalPrices.payWhirl.subscription.price = priceVal;
        window.globalPrices.payWhirl.subscription.groupPrice = groupPriceVal;
        window.globalPrices.payWhirl.subscription.compareAt = compareAtVal;
    }
}

// Helper functions for getting elements directly
function getOneTimePriceElement() {
    const oneTimeGroup = document.querySelector('#paywhirl-one-time-purchase-group');
    return oneTimeGroup ? oneTimeGroup.querySelector('.paywhirl-plan-selector-price .paywhirl-price') : null;
}

function getSubscriptionGroupPriceElement() {
    const subscriptionGroup = document.querySelector('#paywhirl-plan-selector-group-22a3d0d027fcdf40dec221093eff9c2be9d9623d');
    return subscriptionGroup ? subscriptionGroup.querySelector('.paywhirl-plan-selector-group-price .paywhirl-price') : null;
}

function getSubscriptionPriceElements() {
    const subscriptionGroup = document.querySelector('#paywhirl-plan-selector-group-22a3d0d027fcdf40dec221093eff9c2be9d9623d');
    if (subscriptionGroup) {
        const priceContainer = subscriptionGroup.querySelector('.paywhirl-plan-selector-price[style*="display: block"]') ||
                               subscriptionGroup.querySelector('.paywhirl-plan-selector-price');
        if (priceContainer) {
            const comparePriceElement = priceContainer.querySelector('.paywhirl-compare-at-price');
            const priceElement = priceContainer.querySelector('.paywhirl-price');
            return { comparePriceElement, priceElement };
        }
    }
    return { comparePriceElement: null, priceElement: null };
}

/************************************
 * Multiple Buy Options Initialization
 ************************************/
function waitForMultipleBuyOptions() {
    let attempts = 0;
    const maxAttempts = 20;
    const interval = setInterval(() => {
        attempts++;
        console.log(`Checking for Multiple Buy options, attempt ${attempts}...`);

        let mbOptions = document.querySelectorAll(".dbtfy-quantity-breaks__quantity");
        if (mbOptions.length > 0) {
            mbOptions = Array.from(mbOptions);
            // Filter out placeholder options
            mbOptions = mbOptions.filter(option => {
                const label = option.querySelector("label");
                if (!label) return false;
                const text = label.textContent || "";
                return !text.includes("Buy _COUNT_:");
            });

            if (mbOptions.length > 0) {
                console.log(`Found ${mbOptions.length} valid Multiple Buy options.`);
                clearInterval(interval);
                initializeMultipleBuyOptions(mbOptions);
            } else {
                console.log("Only placeholder Multiple Buy options found, retrying...");
            }

        } else {
            if (attempts >= maxAttempts) {
                console.warn("Multiple Buy options not found after maximum attempts.");
                clearInterval(interval);
            }
        }
    }, 1000);
}

function initializeMultipleBuyOptions(mbOptions) {
    console.log("Initializing Multiple Buy options...");
    logMultipleBuyAllOptions(mbOptions);
    attachMultipleBuyOptionListeners(mbOptions);

    // Delay before checking initially selected option to ensure placeholders replaced
    setTimeout(() => {
        logCurrentlySelectedMultipleBuyOption(mbOptions);
        // After selecting initial quantity, update PayWhirl prices once
        updatePayWhirlPrices();
    }, 500);
}

function logMultipleBuyAllOptions(mbOptions) {
    console.log("Logging all Multiple Buy option prices...");
    window.globalPrices.multipleBuy.options = [];
    mbOptions.forEach((option, index) => {
        console.log(`Logging option #${index + 1}:`);
        logMultipleBuyOptionPrices(option);
    });
}

function attachMultipleBuyOptionListeners(mbOptions) {
    console.log("Attaching event listeners to Multiple Buy options...");
    mbOptions.forEach(option => {
        const input = option.querySelector('input[type="radio"]');
        if (input) {
            console.log("Attaching listener to Multiple Buy option with value:", input.value);
            input.addEventListener("change", function (e) {
                console.log("Multiple Buy option change detected. Value:", e.target.value);
                if (e.target.checked) {
                    console.log("This option is now selected:", e.target.value);
                    logMultipleBuyOptionPrices(option);
                    updateSelectedMultipleBuyOption(e.target.value);
                    // After changing quantity, update PayWhirl prices
                    updatePayWhirlPrices();
                } else {
                    console.log("Option changed but not checked:", e.target.value);
                }
            });
        } else {
            console.log("No input found in this Multiple Buy option. Cannot attach listener.");
        }
    });
}

function logCurrentlySelectedMultipleBuyOption(mbOptions) {
    console.log("Checking which Multiple Buy option is currently selected...");
    const selectedOption = mbOptions.find(opt => {
        const input = opt.querySelector('input[type="radio"]');
        return input && input.checked;
    });
    if (selectedOption) {
        console.log("Initially selected Multiple Buy option found.");
        logMultipleBuyOptionPrices(selectedOption);
        const input = selectedOption.querySelector('input[type="radio"]');
        if (input) {
            updateSelectedMultipleBuyOption(input.value);
        }
    } else {
        console.log("No Multiple Buy option selected initially.");
    }
}

function logMultipleBuyOptionPrices(option) {
    if (!option) {
        console.log("No option provided to logMultipleBuyOptionPrices.");
        return;
    }

    console.log("---- Multiple Buy Option ----");
    const input = option.querySelector('input[type="radio"]');
    const label = option.querySelector("label");
    const discountedPriceEl = option.querySelector(".dbtfy-quantity-breaks__discounted-price .money");
    const originalPriceEl = option.querySelector(".dbtfy-quantity-breaks__original-price .money");

    let quantityValue = input ? input.value : null;
    let labelText = label ? label.textContent.trim() : null;
    let discountedPrice = discountedPriceEl ? discountedPriceEl.textContent.trim() : null;
    let originalPrice = originalPriceEl ? originalPriceEl.textContent.trim() : null;

    console.log("Quantity Value:", quantityValue, "Checked?:", input && input.checked);
    console.log("Option Label Text:", labelText || "No label found for this option.");
    console.log("Discounted Price:", discountedPrice || "No discounted price element found for this option.");
    console.log("Original (Compare-At) Price:", originalPrice || "No original price element found for this option.");
    console.log("---- End of Multiple Buy Option ----");

    // Store globally
    if (quantityValue) {
        const optionData = { quantityValue, discountedPrice, originalPrice };
        const existingIndex = window.globalPrices.multipleBuy.options.findIndex(o => o.quantityValue === quantityValue);
        if (existingIndex >= 0) {
            window.globalPrices.multipleBuy.options[existingIndex] = optionData;
        } else {
            window.globalPrices.multipleBuy.options.push(optionData);
        }
    }
}

function updateSelectedMultipleBuyOption(quantityValue) {
    const selectedData = window.globalPrices.multipleBuy.options.find(o => o.quantityValue === quantityValue);
    if (selectedData) {
        window.globalPrices.multipleBuy.selectedOption = quantityValue;
        window.globalPrices.multipleBuy.selectedPrice = selectedData.discountedPrice;
        console.log(`Global selected Multiple Buy option updated: ${quantityValue}, Price: ${selectedData.discountedPrice}`);
    }
}
